export default __webpack_public_path__ + "static/ring3-505d8194fe0c2ea93f6903eeba1d766f.png";